// Rei do Arremate — setas dos carrosséis (fileira de categorias e vitrines).
document.addEventListener('click', (event) => {
  const botao = event.target.closest('[data-rda-nav] button');
  if (!botao) return;
  const secao = botao.closest('section');
  const trilho = secao && secao.querySelector('[data-rda-track]');
  if (!trilho) return;
  const passo = Math.max(trilho.clientWidth * 0.8, 200);
  trilho.scrollBy({ left: passo * Number(botao.dataset.dir), behavior: 'smooth' });
});

// Aviso de produto vendido: o link antigo do produto redireciona para a categoria com ?vendido=1.
// Mostra o aviso e tira o parâmetro do endereço (não reaparece ao recarregar ou compartilhar).
(() => {
  const aviso = document.querySelector('[data-rda-vendido]');
  const url = new URL(window.location.href);
  if (!aviso || !url.searchParams.has('vendido')) return;
  aviso.hidden = false;
  url.searchParams.delete('vendido');
  history.replaceState(history.state, '', url);
})();

// Vitrine "Novidades do galpão": troca a data do último dia de postagem por "hoje" ou "ontem"
// (feito no navegador porque a página pode ficar em cache de um dia para o outro).
document.querySelectorAll('[data-rda-dia]').forEach((el) => {
  const [ano, mes, dia] = el.dataset.rdaDia.split('-').map(Number);
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const diferenca = Math.round((hoje - new Date(ano, mes - 1, dia)) / 86400000);
  if (diferenca === 0) el.textContent = 'hoje';
  else if (diferenca === 1) el.textContent = 'ontem';
});

// Filtros da categoria: os links de etiqueta (sem avaria, última unidade, marca, grupos) levam junto
// o filtro de preço e a ordem que estão na busca do endereço; só a página volta para a primeira.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-rda-busca]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
  const atual = new URLSearchParams(window.location.search);
  atual.delete('page');
  atual.delete('vendido');
  if (![...atual.keys()].length) return;
  const destino = new URL(link.href, window.location.origin);
  for (const [chave, valor] of atual) if (!destino.searchParams.has(chave)) destino.searchParams.append(chave, valor);
  event.preventDefault();
  window.location.href = destino.toString();
});

// Menus "Preço" e "Marca": abrir um fecha o outro; clicar fora ou Esc fecha.
document.addEventListener('toggle', (event) => {
  const aberto = event.target;
  if (!aberto.matches || !aberto.matches('.rda-filtro-drop') || !aberto.open) return;
  document.querySelectorAll('.rda-filtro-drop[open]').forEach((outro) => { if (outro !== aberto) outro.open = false; });
}, true);
document.addEventListener('click', (event) => {
  if (event.target.closest('.rda-filtro-drop')) return;
  document.querySelectorAll('.rda-filtro-drop[open]').forEach((d) => { d.open = false; });
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.rda-filtro-drop[open]').forEach((d) => { d.open = false; });
});
